<div class="edit-modal kw-dialog">

  <div class="modal-header">
    <div>
      <h2 class="modal-title">Edit {{"Product" | tenantWords}} Code</h2>
      <div class="modal-subtitle">{{"Lot" | tenantWords}} {{this.lot.lotNumber}}</div>
    </div>
    <button mat-icon-button class="close-btn" type="button" aria-label="Close" (click)="cancel()">
      <fa-icon [icon]="faXmark"></fa-icon>
    </button>
  </div>

  <div class="modal-body" [nbSpinner]="this.isLoading">
    <section class="form-section">
      <div class="section-head">
        <fa-icon [icon]="faBoxes" class="section-icon"></fa-icon>
        <h3>{{"Product" | tenantWords}} Code</h3>
      </div>

      <div class="current-product" *ngIf="this.originalProductName">
        <span class="current-label">Current</span>
        <span class="current-value">{{this.originalProductName}}</span>
      </div>

      <mat-form-field appearance="outline" class="product-field">
        <mat-label>New {{"Product" | tenantWords}} Code</mat-label>
        <input type="text" matInput [formControl]="productControl" [matAutocomplete]="auto" placeholder="Type to search...">
        <button *ngIf="productControl.value" matSuffix mat-icon-button aria-label="Clear" type="button"
          (click)="productControl.setValue('')">
          <fa-icon [icon]="faXmark"></fa-icon>
        </button>
        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayProduct" (optionSelected)="onProductSelected($event)">
          <mat-option *ngFor="let item of filteredInventoryItems; trackBy: trackByItem" [value]="item">
            {{item.name}}
          </mat-option>
          <mat-option *ngIf="filteredInventoryItems.length === 0" disabled>
            No {{"Products" | tenantWords}} found
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </section>
  </div>

  <div class="modal-footer">
    <button mat-stroked-button type="button" (click)="cancel()">Cancel</button>
    <button mat-raised-button color="primary" type="button" (click)="save()" [disabled]="!selectedProductId || this.isLoading">
      <fa-icon [icon]="faCheck" class="me-2"></fa-icon>Save
    </button>
  </div>

</div>
